export default defineNuxtPlugin(async (nuxtApp) => {
  const [locale, globalPageSettings, dictionary, audiences] = await Promise.all(
    [
      import('./02.locale.client.internal'),
      import('./03.globalPageSettings.client.internal'),
      import('./05.dictionary.client.internal'),
      import('./11.audiences.internal')
    ]
  );

  // init these async plugins in parallel
  await Promise.all([
    locale.default(nuxtApp),
    globalPageSettings.default(nuxtApp),
    dictionary.default(nuxtApp),
    audiences.default(nuxtApp)
  ]);
});
